// extracted by mini-css-extract-plugin
export default {"support":"style_support__0Lbsb"};